module.exports = __webpack_public_path__ + "static/media/fly0026.bb64a113.webp";